module.exports = __webpack_public_path__ + "media/icons/saral-share-1419d9db.svg";